export class CartOrder {
    public CardName: string;
    public CartItems: CartItems[];
    public Description: string;
    public PaymentReceiveMethodId: string;
    constructor(CardName: string, CartItems: CartItems[], Description: string, PaymentReceiveMethodId: string) {
        this.CardName = CardName;
        this.CartItems = CartItems;
        this.Description = Description;
        this.PaymentReceiveMethodId = PaymentReceiveMethodId;
    }
}


export class CartItems {
    public CartItemGUID: string;
    constructor(CartItemGUID: string) {
        this.CartItemGUID = CartItemGUID;
    }
}